<script setup lang="ts">
import IOHeroContentPage from "@/components/io/io-hero/content/IOHeroContentPage.vue";
import IOHeroContentProduct from "@/components/io/io-hero/content/IOHeroContentProduct.vue";
import IOHeroContentContent from "@/components/io/io-hero/content/IOHeroContentContent.vue";
const props = withDefaults(defineProps<{
  id: string,
  content: {
    model?: ContentModel,
    transition?: {
      mode?: 'out-in' | 'duo'
    },
    content: {
      title?: string,
      description?: string,
    }
  }
}>(), {
  id: '',
  content: () => {
    return {
      model: 'page',
      transition: {
        mode: 'out-in'
      },
      content: {
        title: 'Hero Title',
        description: 'Hero Description',
      }
    }
  },
})

const key = computed(() => props.id)

const heroContent = computed(() => props.content)
const content = computed(() => heroContent.value.content)

const contentModel = computed(() => heroContent.value?.model || 'page')

// Settings defined by the hero content object
const transitionMode = ref('out-in')

watch(heroContent, (heroContent, prevHeroContent) => {
  // console.log('heroContent', heroContent)
  // console.log('prevHeroContent', prevHeroContent)

  // Determine the requierments of the new media

  // If there is no previous media or the transition mode is not set, or set to 'out-in', then transition mode is out-in
  if (prevHeroContent && heroContent.transition?.mode === 'duo') {
    transitionMode.value = 'duo'
  } else {
    transitionMode.value = 'out-in'
  }


}, {
  immediate: true,
  deep: true
})
</script>

<template>
<div class="layer layer-content" :class="key">
  <template v-if="transitionMode === 'out-in'">
    <transition name="herocontent" mode="out-in" appear>
      <IOHeroContentPage v-if="contentModel === 'page'" :content="content" :key="key + 'page'" :id="key" />
      <IOHeroContentContent v-else-if="contentModel === 'content'" :content="content" :key="key + 'content'" :id="key" />
      <IOHeroContentProduct v-else-if="contentModel === 'product'" :content="content" :key="key + 'product'" :id="key" />
    </transition>
  </template>

  <template v-if="transitionMode === 'duo'">
    <transition name="outgoing" appear>
      <IOHeroContentPage v-if="contentModel === 'page'" :content="content" :key="key + 'page'" :id="key" />
      <IOHeroContentContent v-else-if="contentModel === 'content'" :content="content" :key="key + 'content'" :id="key" />
      <IOHeroContentProduct v-else-if="contentModel === 'product'" :content="content" :key="key + 'product'" :id="key" />
    </transition>
    <transition name="incoming" appear>
      <IOHeroContentPage v-if="contentModel === 'page'" :content="content" :key="key + 'page'" :id="key" />
      <IOHeroContentContent v-else-if="contentModel === 'content'" :content="content" :key="key + 'content'" :id="key" />
      <IOHeroContentProduct v-else-if="contentModel === 'product'" :content="content" :key="key + 'product'" :id="key" />
    </transition>
  </template>
</div>
</template>

<style lang="scss" scoped>
.herocontent-enter-from {
  opacity: 0;
  transform: translateX(-32px);
}

.herocontent-enter-to {
  opacity: 1;
  transform: translateX(0);
}

.herocontent-enter-active {
  transition: all 0.5s ease-in-out;
}

.herocontent-leave-from {
  opacity: 1;
  transform: translateX(0);
}

.herocontent-leave-to {
  opacity: 0;
  transform: translateX(-32px);
}

.herocontent-leave-active {
  transition: all 0.5s ease-in-out;
  transition-delay: 0.05s;
}



.hero-slide {
  width: 100%;
  height: 100%;

  flex:1;

  display:flex;
  flex-direction: column;

  .media {
    width:100%;
    height:100%;
    flex:1; // ensures the media layer takes up the full height of the hero
  }
  &.media-image {
    overflow:hidden;

    .media.image {
      display:flex;
      flex-direction: column;
    }
  }
}


</style>  